<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    components: {},
    mounted () {
        if (process.env.NODE_ENV === 'production') {
            // this.$router.push({name: 'prototype'})
            this.$router.push({name: 'hello'})
        } else {
            // this.$router.push({name: 'prototype'})
            this.$router.push({name: 'hello'})
            // this.$router.push({name: 'game-result'})
            // this.$router.push({name: 'game-goods'})
            // this.$router.push({name: 'game-good', params: {id: 6}})
            // this.$router.push({name: 'game-runtime'})
        }
    }
}
</script>

<style lang="stylus">
    @import "./assets/stylus/main.styl"
    #app {
        background-image url('~@/assets/images/bg.svg')
        background-repeat no-repeat
        background-position 59% 8%
        min-height 100%
        +layout-sm() {
            display flex
        }
    }
</style>



